// save ไว้ที่ D:\vuejs\project\tai_book\src\store\api\services\tscService.js
import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
  // reqbill Service ------------------------------------
  reqbillList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=list' + param,
      credentials
    )
  },
  reqbillItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=listbyparam',
      credentials
    )
  },
  reqbillMaxNumber(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=MaxNumber',
      credentials
    )
  },
  reqbillGetToken(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=token',
      credentials
    )
  },
  reqbillReportExcel(credentials, actionName = 'reportexcel') {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=' + actionName,
      credentials
    )
  },
  reqbillListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=listbyparam',
      credentials
    )
  },
  reqbillChart(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=chart',
      credentials
    )
  },
  reqbillInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=insert',
      credentials
    )
  },
  reqbillUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=update',
      credentials
    )
  },
  reqbillStampDate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=stampdate',
      credentials
    )
  },
  reqbillDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=delete',
      credentials
    )
  },
  reqbillOperNoList(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=reqbill&action=OperNoAll',
      credentials
    )
  },
  // part_tb Service ------------------------------------
  part_tbList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=part_tb&action=list' + param,
      credentials
    )
  },
  part_tbItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=part_tb&action=listbyparam',
      credentials
    )
  },
  part_tbListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=part_tb&action=listbyparam',
      credentials
    )
  },
  part_tbInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=part_tb&action=insert',
      credentials
    )
  },
  part_tbUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=part_tb&action=update',
      credentials
    )
  },
  part_tbDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=part_tb&action=delete',
      credentials
    )
  },
  // product_tb Service ------------------------------------
  product_tbList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=product_tb&action=list' + param,
      credentials
    )
  },
  product_tbItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=product_tb&action=listbyparam',
      credentials
    )
  },
  product_tbListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=product_tb&action=listbyparam',
      credentials
    )
  },
  product_tbInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=product_tb&action=insert',
      credentials
    )
  },
  product_tbUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=product_tb&action=update',
      credentials
    )
  },
  product_tbDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=product_tb&action=delete',
      credentials
    )
  },
  // testtype_tb Service ------------------------------------
  testtype_tbList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testtype_tb&action=list' + param,
      credentials
    )
  },
  testtype_tbItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=testtype_tb&action=listbyparam',
      credentials
    )
  },
  testtype_tbListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testtype_tb&action=listbyparam',
      credentials
    )
  },
  testtype_tbInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testtype_tb&action=insert',
      credentials
    )
  },
  testtype_tbUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testtype_tb&action=update',
      credentials
    )
  },
  testtype_tbDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testtype_tb&action=delete',
      credentials
    )
  },
  // testgroup_tb Service ------------------------------------
  testgroup_tbList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=list' + param,
      credentials
    )
  },
  testgroup_tbItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=listbyparam',
      credentials
    )
  },
  testgroup_tbListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=listbyparam',
      credentials
    )
  },
  testgroup_tbInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=insert',
      credentials
    )
  },
  testgroup_tbUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=update',
      credentials
    )
  },
  testgroup_tbDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=delete',
      credentials
    )
  },
  // winspeed Service ------------------------------------
  getWinspeedJobCode() {
    let credentials = {
      "table": "winspeed_tai.dbo.emjob",
      "value": "jobCode",
      "text": "jobCode +' '+ jobName",
      "filter": "left(JobCode ,2) >= right(YEAR(GETDATE())+543,2)",
      "sortBy": "JobCode desc"
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=winspeedData',
      credentials
    )
  },
  getWinspeedJobID() {
    let credentials = {
      "table": "winspeed_tai.dbo.emjob",
      "value": "jobID",
      "text": "jobCode +' '+ jobName",
      "filter": "left(JobCode ,2) >= right(YEAR(GETDATE())+543,2)",
      "sortBy": "JobCode desc"
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=winspeedData',
      credentials
    )
  },
  getWinspeedDeptID() {
    let credentials = {
      "table": "winspeed_tai.dbo.emDept",
      "value": "DeptID",
      "text": "DeptCode +'-'+DeptName",
      "filter": "(DeptName like '%ทดสอบ%')",
      "sortBy": "DeptCode"
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=winspeedData',
      credentials
    )
  },
  getWinspeedGoodID() {
    let credentials = {
      "table": "winspeed_tai.dbo.EMGood",
      "value": "GoodID",
      "text": "GoodCode +' '+ GoodName1",
      "filter": "GoodCode like 'TS%ALL'",
      "sortBy": "GoodCode"
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=winspeedData',
      credentials
    )
  },
  getWinspeedGoodTypeID() {
    let credentials = {
      "table": "winspeed_tai.dbo.EMGoodType",
      "value": "GoodTypeID",
      "text": "GoodTypeCode +' '+ GoodTypeName",
      "filter": "GoodTypeCode like 'TS%'",
      "sortBy": "GoodTypeCode"
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=testgroup_tb&action=winspeedData',
      credentials
    )
  },

  // customer Service ------------------------------------
  customerList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=list' + param,
      credentials
    )
  },
  customerItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=listbyparam',
      credentials
    )
  },
  customercontactInfo(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=ContactInfo',
      credentials
    )
  },
  customerInfo(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=CustInfo',
      credentials
    )
  },
  customerListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=listbyparam',
      credentials
    )
  },
  customerInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=insert',
      credentials
    )
  },
  customerUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=update',
      credentials
    )
  },
  customerDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customer&action=delete',
      credentials
    )
  },
  // customercontact Service ------------------------------------
  customercontactList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontact&action=list' + param,
      credentials
    )
  },
  customercontactItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontact&action=listbyparam',
      credentials
    )
  },
  customercontactListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontact&action=listbyparam',
      credentials
    )
  },
  customercontactInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontact&action=insert',
      credentials
    )
  },
  customercontactUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontact&action=update',
      credentials
    )
  },
  customercontactDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontact&action=delete',
      credentials
    )
  },
  // tester Service ------------------------------------
  testerList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=tester&action=list' + param,
      credentials
    )
  },
  testerItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=tester&action=listbyparam',
      credentials
    )
  },
  testerListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=tester&action=listbyparam',
      credentials
    )
  },
  testerInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=tester&action=insert',
      credentials
    )
  },
  testerUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=tester&action=update',
      credentials
    )
  },
  testerDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=tester&action=delete',
      credentials
    )
  },
  // emprole Service ------------------------------------
  emproleList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=emprole&action=list' + param,
      credentials
    )
  },
  emproleItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=emprole&action=listbyparam',
      credentials
    )
  },
  emproleListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=emprole&action=listbyparam',
      credentials
    )
  },
  emproleInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=emprole&action=insert',
      credentials
    )
  },
  emproleUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=emprole&action=update',
      credentials
    )
  },
  emproleDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=emprole&action=delete',
      credentials
    )
  },
  // quotation Service ------------------------------------
  quotationList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=list' + param,
      credentials
    )
  },
  quotationItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=listbyparam',
      credentials
    )
  },
  quotationSumbyTimeType(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=SumDashboard',
      credentials
    )
  },
  quotationListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=listbyparam',
      credentials
    )
  },
  quotationInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=insert',
      credentials
    )
  },
  quotationUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=update',
      credentials
    )
  },
  quotationDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotation&action=delete',
      credentials
    )
  },
  // quotationdt Service ------------------------------------
  quotationdtList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=list' + param,
      credentials
    )
  },
  quotationdtItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=listbyparam',
      credentials
    )
  },
  quotationdtListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=listbyparam',
      credentials
    )
  },
  quotationdtInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=insert',
      credentials
    )
  },
  quotationdtUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=update',
      credentials
    )
  },
  quotationdtMoveList(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=movelist',
      credentials
    )
  },
  quotationdtDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=quotationdt&action=delete',
      credentials
    )
  },
  // sample Service ------------------------------------
  sampleList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=list' + param,
      credentials
    )
  },
  sampleItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=listbyparam',
      credentials
    )
  },
  sampleListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=listbyparam',
      credentials
    )
  },
  sampleListPlan(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=ListPlan',
      credentials
    )
  },
  sampleInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=insert',
      credentials
    )
  },
  sampleUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=update',
      credentials
    )
  },
  sampleUpdateSupervice(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=updatesupervice',
      credentials
    )
  },
  sampleUpdatePlan(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=updateplan',
      credentials
    )
  },
  sampleDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sample&action=delete',
      credentials
    )
  },
  // enginetype Service ------------------------------------
  enginetypeList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=enginetype&action=list' + param,
      credentials
    )
  },
  enginetypeItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=enginetype&action=listbyparam',
      credentials
    )
  },
  enginetypeListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=enginetype&action=listbyparam',
      credentials
    )
  },
  enginetypeInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=enginetype&action=insert',
      credentials
    )
  },
  enginetypeUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=enginetype&action=update',
      credentials
    )
  },
  enginetypeDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=enginetype&action=delete',
      credentials
    )
  },
  // autobrand Service ------------------------------------
  autobrandList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=autobrand&action=list' + param,
      credentials
    )
  },
  autobrandItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=autobrand&action=listbyparam',
      credentials
    )
  },
  autobrandListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autobrand&action=listbyparam',
      credentials
    )
  },
  autobrandInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autobrand&action=insert',
      credentials
    )
  },
  autobrandUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autobrand&action=update',
      credentials
    )
  },
  autobrandDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autobrand&action=delete',
      credentials
    )
  },
  // autotype Service ------------------------------------
  autotypeList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=autotype&action=list' + param,
      credentials
    )
  },
  autotypeItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=autotype&action=listbyparam',
      credentials
    )
  },
  autotypeListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autotype&action=listbyparam',
      credentials
    )
  },
  autotypeInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autotype&action=insert',
      credentials
    )
  },
  autotypeUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autotype&action=update',
      credentials
    )
  },
  autotypeDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=autotype&action=delete',
      credentials
    )
  },
  // sendreport Service ------------------------------------
  sendreportList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=sendreport&action=list' + param,
      credentials
    )
  },
  sendreportItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=sendreport&action=listbyparam',
      credentials
    )
  },
  sendreportListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sendreport&action=listbyparam',
      credentials
    )
  },
  sendreportInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sendreport&action=insert',
      credentials
    )
  },
  sendreportUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sendreport&action=update',
      credentials
    )
  },
  sendreportDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sendreport&action=delete',
      credentials
    )
  },
  // review Service ------------------------------------
  reviewList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=review&action=list' + param,
      credentials
    )
  },
  reviewItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=review&action=listbyparam',
      credentials
    )
  },
  reviewListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=review&action=listbyparam',
      credentials
    )
  },
  reviewInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=review&action=insert',
      credentials
    )
  },
  reviewUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=review&action=update',
      credentials
    )
  },
  reviewDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=review&action=delete',
      credentials
    )
  },
  // receiptbill Service ------------------------------------
  receiptbillList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=receiptbill&action=list' + param,
      credentials
    )
  },
  receiptbillItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=receiptbill&action=listbyparam',
      credentials
    )
  },
  receiptbillListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=receiptbill&action=listbyparam',
      credentials
    )
  },
  receiptbillInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=receiptbill&action=insert',
      credentials
    )
  },
  receiptbillUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=receiptbill&action=update',
      credentials
    )
  },
  receiptbillDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=receiptbill&action=delete',
      credentials
    )
  },
  // invoicebill Service ------------------------------------
  invoicebillList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=invoicebill&action=list' + param,
      credentials
    )
  },
  invoicebillItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=invoicebill&action=listbyparam',
      credentials
    )
  },
  invoicebillListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=invoicebill&action=listbyparam',
      credentials
    )
  },
  invoicebillInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=invoicebill&action=insert',
      credentials
    )
  },
  invoicebillUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=invoicebill&action=update',
      credentials
    )
  },
  invoicebillDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=invoicebill&action=delete',
      credentials
    )
  },
  // customercontactvw Service ------------------------------------
  customercontactvwList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontactvw&action=list' + param,
      credentials
    )
  },
  customercontactvwItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontactvw&action=listbyparam',
      credentials
    )
  },
  customercontactvwListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontactvw&action=listbyparam',
      credentials
    )
  },
  customercontactvwInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontactvw&action=insert',
      credentials
    )
  },
  customercontactvwUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontactvw&action=update',
      credentials
    )
  },
  customercontactvwDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=customercontactvw&action=delete',
      credentials
    )
  },
  // arquotationhd Service ------------------------------------
  arquotationhdList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationhd&action=list' + param,
      credentials
    )
  },
  arquotationhdItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationhd&action=listbyparam',
      credentials
    )
  },
  arquotationhdListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationhd&action=listbyparam',
      credentials
    )
  },
  arquotationhdInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationhd&action=insert',
      credentials
    )
  },
  arquotationhdUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationhd&action=update',
      credentials
    )
  },
  arquotationhdDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationhd&action=delete',
      credentials
    )
  },
  // arquotationdt Service ------------------------------------
  arquotationdtList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationdt&action=list' + param,
      credentials
    )
  },
  arquotationdtItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationdt&action=listbyparam',
      credentials
    )
  },
  arquotationdtListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationdt&action=listbyparam',
      credentials
    )
  },
  arquotationdtInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationdt&action=insert',
      credentials
    )
  },
  arquotationdtUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationdt&action=update',
      credentials
    )
  },
  arquotationdtDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arquotationdt&action=delete',
      credentials
    )
  },
  // arcustomer Service ------------------------------------
  arcustomerList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=arcustomer&action=list' + param,
      credentials
    )
  },
  arcustomerItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=arcustomer&action=listbyparam',
      credentials
    )
  },
  arcustomerListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arcustomer&action=listbyparam',
      credentials
    )
  },
  arcustomerInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arcustomer&action=insert',
      credentials
    )
  },
  arcustomerUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arcustomer&action=update',
      credentials
    )
  },
  arcustomerDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arcustomer&action=delete',
      credentials
    )
  },
  // arpreinvoicebill Service ------------------------------------
  arpreinvoicebillList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=arpreinvoicebill&action=list' + param,
      credentials
    )
  },
  arpreinvoicebillItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=arpreinvoicebill&action=listbyparam',
      credentials
    )
  },
  arpreinvoicebillListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arpreinvoicebill&action=listbyparam',
      credentials
    )
  },
  arpreinvoicebillInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arpreinvoicebill&action=insert',
      credentials
    )
  },
  arpreinvoicebillUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arpreinvoicebill&action=update',
      credentials
    )
  },
  arpreinvoicebillDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=arpreinvoicebill&action=delete',
      credentials
    )
  },
  // prequotationbill Service ------------------------------------
  prequotationbillList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationbill&action=list' + param,
      credentials
    )
  },
  prequotationbillItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationbill&action=listbyparam',
      credentials
    )
  },
  prequotationbillListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationbill&action=listbyparam',
      credentials
    )
  },
  prequotationbillInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationbill&action=insert',
      credentials
    )
  },
  prequotationbillUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationbill&action=update',
      credentials
    )
  },
  prequotationbillDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationbill&action=delete',
      credentials
    )
  },
  // prequotationdt Service ------------------------------------
  prequotationdtMoveList(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=movelist',
      credentials
    )
  },
  prequotationdtList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=list' + param,
      credentials
    )
  },
  prequotationdtItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=listbyparam',
      credentials
    )
  },
  prequotationdtListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=listbyparam',
      credentials
    )
  },
  prequotationdtInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=insert',
      credentials
    )
  },
  prequotationdtUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=update',
      credentials
    )
  },
  prequotationdtDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=prequotationdt&action=delete',
      credentials
    )
  },
  // sampletrack Service ------------------------------------
  sampletrackList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=list' + param,
      credentials
    )
  },
  sampletrackItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=listbyparam',
      credentials
    )
  },
  sampletrackListByParam(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=listbyparam',
      credentials
    )
  },
  sampletrackInsert(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=insert',
      credentials
    )
  },
  sampletrackUpdate(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=update',
      credentials
    )
  },
  sampletrackDelete(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=delete',
      credentials
    )
  },
  sampletrackOperNoAll(credentials) {
    return Api.httpServer().post(
      'tsc/default.asp?controller=sampletrack&action=OperNoAll',
      credentials
    )
  },
  //<services>
  errorHandel(res) {
    if (res.status === 401) {
      store.state.users.main = {}
      router.push('/signin')
    }
  }
}
